import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
    statusCode: number;
    message: string;
}

export const emailTemplateApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        addEmailTemplate: builder.mutation<CommonResponseType & { data?: any }, any>({
            query: (body) => ({
                url: END_POINTS.emailtemplate,
                method: 'POST',
                body,
            }),
        }),
        updateEmailTemplate: builder.mutation<
            CommonResponseType & { data?: any },
            { body: any, id: string }
        >({
            query: ({ body, id }) => ({
                url: `${END_POINTS.emailtemplate}/${id}`,
                method: 'PUT',
                body,
            }),
        }),
        getEmailTemplateList: builder.query<
            CommonResponseType & {
                data: {
                    templates: any[];
                    count: number;
                };
            },
            {
                page: number;
                limit: number;
                search?: string;
            }
        >({
            query: ({ page, limit, search }) => ({
                url: `${END_POINTS.emailtemplate}/list?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`,
                method: 'GET',
            }),
        }),
        getEmailTemplateById: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.emailtemplate}/${id}`,
                method: 'GET',
            }),
        }),
        deleteEmailTemplate: builder.mutation<
            CommonResponseType & { data?: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.emailtemplate}/${id}`,
                method: 'DELETE',
                body: {},
            }),
        }),
    }),
});

export const {
    useAddEmailTemplateMutation,
    useUpdateEmailTemplateMutation,
    useLazyGetEmailTemplateListQuery,
    useGetEmailTemplateByIdQuery,
    useLazyGetEmailTemplateByIdQuery,
    useDeleteEmailTemplateMutation,
} = emailTemplateApi;
